import { render } from "./ReceivingHistoryModal.vue?vue&type=template&id=a9bd7636&scoped=true"
import script from "./ReceivingHistoryModal.vue?vue&type=script&lang=js"
export * from "./ReceivingHistoryModal.vue?vue&type=script&lang=js"

import "./ReceivingHistoryModal.vue?vue&type=style&index=0&id=a9bd7636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9bd7636"]])

export default __exports__